"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tokens = void 0;
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * Shared design-token contract (StyleX themable variables).
 *
 * ONE `defineVars` call declares the canonical token *names* that every
 * product and every shared UI component reads (`tokens.accent`,
 * `tokens.fontFamily`, `tokens.tableBorder`, ...). Because StyleX compiles a
 * `defineVars` group into a single set of CSS custom properties, a component
 * in `web/shared` can reference these and be themed by whichever product it
 * renders under: the product supplies the *values* via `stylex.createTheme`
 * applied at its SPA root, and a shared component needs no product-specific
 * import.
 *
 * The values below are neutral placeholders that surface only when a product
 * does not apply its theme. Keep this the canonical superset: add a token when
 * a real component needs it, not speculatively.
 */ // The token contract consumers read (tokens.accent, tokens.fontFamily, ...).
// Annotated explicitly because Flow's types-first mode can't infer the export
// type through stylex.defineVars()'s mapped return.
const tokens = exports.tokens = {
  fontFamily: "var(--x3zdh)",
  labelFontFamily: "var(--x1kaa2yy)",
  background: "var(--x1o6ovji)",
  textColor: "var(--xi5xdqr)",
  mutedTextColor: "var(--xkvllax)",
  moreMutedTextColor: "var(--xfb0oxp)",
  accent: "var(--x167hgxh)",
  phraseAccent: "var(--xixwj37)",
  spacing: "var(--x1f5ympn)",
  radius: "var(--xdyu3u9)",
  border: "var(--x1cgp455)",
  surfaceSecondary: "var(--xklpxc1)",
  surfaceHover: "var(--xyk3xk5)",
  positive: "var(--xowwio9)",
  warning: "var(--x1lr9spk)",
  negative: "var(--xpjk1k2)",
  tableHeaderBackground: "var(--x12z38cd)",
  tableBorder: "var(--xvbo9y7)",
  tableCellPaddingY: "var(--xs565wo)",
  tableCellPaddingX: "var(--xpheibk)",
  fontSizeDisplay: "var(--xs0q74e)",
  fontSizeTitle: "var(--xzwwe41)",
  fontSizeCardTitle: "var(--x15kw5y8)",
  fontSizeSubtitle: "var(--x4ta5ea)",
  fontSizeBody: "var(--x15qck7k)",
  fontSizeMeta: "var(--xmmpgjz)",
  fontSizeSmall: "var(--x12u8qo5)",
  __themeName__: "x1ywh52i"
};